import AssistChip from 'LuxKit/Chips/AssistChip'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import RadioInput from 'LuxKit/Radio/RadioInput'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import { rem } from 'polished'
import React, { useCallback, useMemo, useRef } from 'react'
import styled from 'styled-components'

const RadioGroup = styled(Group)`
  padding-inline: ${rem(16)};
`

const DEPARTURE_SORT_OPTION_LIST = [
  {
    label: 'Departure soon',
    value: 'departure-soon',
  },
  {
    label: 'Price: Low to high',
    value: 'price-asc',
  },
  {
    label: 'Price: High to low',
    value: 'price-desc',
  },
]

export const DEFAULT_DEPARTURE_SORT_OPTION = DEPARTURE_SORT_OPTION_LIST[0]

interface Props {
  sort?: string
  onChange: (newSort: App.OfferListSortByOptions) => void
}

function CruiseDepartureSortDropdown({ onChange, sort }: Props) {
  const [open, toggleSortOpen, , closeSort] = useToggle()
  const triggerRef = useRef<HTMLButtonElement>(null)

  const onSortChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value as App.OfferListSortByOptions)
    closeSort()
  }, [closeSort, onChange])

  const selectedLabel = useMemo(
    () => DEPARTURE_SORT_OPTION_LIST.find(({ value }) => value === sort)?.label ?? DEFAULT_DEPARTURE_SORT_OPTION.label,
    [sort],
  )

  return <>
    <AssistChip
      variant="filled"
      size="medium"
      onClick={toggleSortOpen}
      endIcon={<DropdownChevron open={open} />}
      ref={triggerRef}
    >
      Sort: {selectedLabel}
    </AssistChip>
    <DropdownList
      size="S"
      anchorRef={triggerRef}
      triggerRef={triggerRef}
      open={open}
      onClose={closeSort}
    >
      <RadioGroup direction="vertical" gap={16}>
        {DEPARTURE_SORT_OPTION_LIST.map(option => <RadioInput
          value={option.value}
          onChange={onSortChange}
          key={option.label}
          checked={option.value === sort}
          name="sort"
        >
          {option.label}
        </RadioInput>)}
      </RadioGroup>
    </DropdownList>
  </>
}

export default React.memo(CruiseDepartureSortDropdown)
